'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$() {
  this.aP9 = null;
  this.aPq = null;
  this.aPc = null;
  this.aPd = false;
  this.aPi = null;
  this.aPj = false;
  this.aPo = null;
  this.aPp = false;
  this.aPa = null;
  this.aPb = false;
  this.aPm = null;
  this.aPn = false;
  this.aPk = null;
  this.aPl = false;
  this.aPe = null;
  this.aPf = false;
  this.aPg = null;
  this.aPh = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ = this;
  this.aP9 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$();
  this.aPq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$.prototype = $p;
$p.eR = (function() {
  return this.aP9;
});
$p.eO = (function() {
  return this.aPq;
});
$p.bW = (function() {
  if ((!this.aPd)) {
    this.aPc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aPd = true;
  }
  return this.aPc;
});
$p.b9 = (function() {
  if ((!this.aPj)) {
    this.aPi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aPj = true;
  }
  return this.aPi;
});
$p.b3 = (function() {
  if ((!this.aPp)) {
    this.aPo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aPp = true;
  }
  return this.aPo;
});
$p.aG = (function() {
  if ((!this.aPb)) {
    this.aPa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aPb = true;
  }
  return this.aPa;
});
$p.az = (function() {
  if ((!this.aPn)) {
    this.aPm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aPn = true;
  }
  return this.aPm;
});
$p.aY = (function() {
  if ((!this.aPl)) {
    this.aPk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aPl = true;
  }
  return this.aPk;
});
$p.sZ = (function() {
  if ((!this.aPf)) {
    this.aPe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Port/Airport of Loading";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aPf = true;
  }
  return this.aPe;
});
$p.afr = (function() {
  if ((!this.aPh)) {
    this.aPg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aPh = true;
  }
  return this.aPg;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$, "app.data.data_point_types$package$PlaceOfLoadingForm$", ({
  Gj: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$() {
  this.aP7 = null;
  this.aP8 = false;
  this.aP5 = null;
  this.aP6 = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$.prototype = $p;
$p.aA = (function() {
  if ((!this.aP8)) {
    this.aP7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aP8 = true;
  }
  return this.aP7;
});
$p.afj = (function() {
  if ((!this.aP6)) {
    this.aP5 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$().sZ();
    this.aP6 = true;
  }
  return this.aP5;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$, "app.data.data_point_types$package$PlaceOfLoading$", ({
  Gi: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoading$ };
//# sourceMappingURL=app.data.data_point_types$package$-Place-Of-Loading$.js.map
